var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartSolid = function SvgHeartSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.993 3.717c-2.34-2.045-5.8-2.463-8.488-.167-2.907 2.483-3.329 6.666-1.03 9.624.872 1.123 2.575 2.81 4.212 4.354a184.807 184.807 0 0 0 4.138 3.775c.076.068.172.153.263.221.11.083.267.185.476.248.28.083.579.083.858 0 .21-.063.367-.165.476-.248.092-.068.187-.153.264-.22l.015-.015a184.98 184.98 0 0 0 4.123-3.76c1.636-1.546 3.34-3.232 4.212-4.355 2.29-2.947 1.932-7.162-1.041-9.633-2.717-2.258-6.141-1.87-8.478.176Z",
    fill: "currentcolor"
  })));
};
export default SvgHeartSolid;